import { useEffect, useState } from "react";
import ThemeMaker from "../../components/thememaker";
import { config } from "../../utils/config";
import axios from "axios";
import "./McrBrands.css";

const LIMIT = 50;

function getPageNumbers(current, total) {
    const pages = [];
    const delta = 1;
    for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
            pages.push(i);
        } else if (pages[pages.length - 1] !== "...") {
            pages.push("...");
        }
    }
    return pages;
}

const MrcProduct = () => {
    const apiUrl = config.apibaseUrl;
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [brandValue, setBrandValue] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const getAllMrcProducts = async (page = 1) => {
        try {
            setLoading(true);
            const response = await fetch(
                `${apiUrl}/catalogue/products/all?page=${page}&limit=${LIMIT}`,
                {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                }
            );
            const data = await response.json();
            setProducts(data?.data || []);
            setCurrentPage(data?.pagination?.page || 1);
            setTotalPages(data?.pagination?.total_pages || 1);
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const searchHandler = async (brand, page = 1) => {
        try {
            setLoading(true);
            const { data } = await axios.get(
                `${apiUrl}/catalogue/products?brand=${encodeURIComponent(
                    brand
                )}&page=${page}&limit=${LIMIT}`
            );
            setProducts(data?.data || []);
            setTotalPages(data?.totalPages || 1);
            setCurrentPage(page);
        } catch (error) {
            console.log("Error ------>", error);
            setProducts([]);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        if (brandValue.trim().length >= 2) {
            searchHandler(brandValue, page);
        } else {
            getAllMrcProducts(page);
        }
    };

    useEffect(() => {
        getAllMrcProducts(1);
    }, []);

    useEffect(() => {
        const searchText = brandValue.trim();
        const timer = setTimeout(() => {
            if (searchText.length >= 2) {
                searchHandler(searchText, 1);
            } else if (searchText.length === 0) {
                getAllMrcProducts(1);
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [brandValue]);

    const money = (v) => (v ? `₹${Number(v).toLocaleString()}` : "—");

    return (
        <ThemeMaker>
            <div className="mcrb-page">
                <div className="mcrb-card">
                    <div className="mcrb-head">
                        <div>
                            <h3 className="mcrb-head-title">MCR Products</h3>
                            <p className="mcrb-head-sub">
                                Master Catalogue Repository &middot; product catalogue
                            </p>
                        </div>
                        {!loading && (
                            <div className="mcrb-head-stats">
                                <div className="mcrb-stat">
                                    <span className="mcrb-stat-num">{products.length}</span>
                                    <span className="mcrb-stat-label">On page</span>
                                </div>
                                <div className="mcrb-stat">
                                    <span className="mcrb-stat-num">{totalPages.toLocaleString()}</span>
                                    <span className="mcrb-stat-label">Pages</span>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="mcrb-toolbar">
                        <div className="mcrb-search">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                                stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                <circle cx="11" cy="11" r="7" />
                                <path d="M21 21l-4.3-4.3" />
                            </svg>
                            <input
                                type="text"
                                placeholder="Search by brand&hellip;"
                                value={brandValue}
                                onChange={(e) => setBrandValue(e.target.value)}
                            />
                            {brandValue && (
                                <button
                                    type="button"
                                    className="mcrb-search-clear"
                                    onClick={() => setBrandValue("")}
                                    aria-label="Clear search"
                                >
                                    &times;
                                </button>
                            )}
                        </div>
                        <span className="mcrb-result-count">
                            Page {currentPage.toLocaleString()} of {totalPages.toLocaleString()}
                        </span>
                    </div>

                    {loading ? (
                        <div className="mcrb-state">
                            <div className="mcrb-spinner" />
                            Loading products&hellip;
                        </div>
                    ) : (
                        <>
                            <div className="mcrb-scroll">
                                <table className="mcrb-table mcrb-table--wide">
                                    <thead>
                                        <tr>
                                            <th className="mcrb-th-rank">#</th>
                                            <th>Product</th>
                                            <th>Brand</th>
                                            <th>Colour</th>
                                            <th>RAM</th>
                                            <th>OS</th>
                                            <th className="mcrb-th-num">MRP</th>
                                            <th className="mcrb-th-num">Amazon</th>
                                            <th className="mcrb-th-num">Flipkart</th>
                                            <th className="mcrb-th-num">Rating</th>
                                            <th className="mcrb-th-num">Reviews</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {products.length > 0 ? (
                                            products.map((item, index) => {
                                                const name = item.product_name || "—";
                                                const initial = name.trim().charAt(0) || "—";
                                                const rank = (currentPage - 1) * LIMIT + index + 1;
                                                return (
                                                    <tr key={item._id || `${name}-${rank}`}>
                                                        <td>
                                                            <span className="mcrb-rank">{rank}</span>
                                                        </td>
                                                        <td>
                                                            <div className="mcrb-brand">
                                                                <span className="mcrb-badge">{initial}</span>
                                                                <span className="mcrb-brand-name mcrb-prod-name" title={name}>
                                                                    {name}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>{item.brand || "—"}</td>
                                                        <td>{item.colour || "—"}</td>
                                                        <td>{item.ram || "—"}</td>
                                                        <td>{item.os || "—"}</td>
                                                        <td className="mcrb-num">{money(item.mrp)}</td>
                                                        <td className="mcrb-num mcrb-num--amazon">
                                                            {money(item.prices?.amazon?.current)}
                                                        </td>
                                                        <td className="mcrb-num mcrb-num--flipkart">
                                                            {money(item.prices?.flipkart?.current)}
                                                        </td>
                                                        <td className="mcrb-num">
                                                            {item.rating ? (
                                                                <span className="mcrb-chip">{item.rating}</span>
                                                            ) : (
                                                                "—"
                                                            )}
                                                        </td>
                                                        <td className="mcrb-num">
                                                            {item.user_rating_count
                                                                ? Number(item.user_rating_count).toLocaleString()
                                                                : "—"}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="11" className="mcrb-empty-row">
                                                    No products found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {totalPages > 1 && (
                                <div className="mcrb-pager">
                                    <span className="mcrb-pager-info">
                                        Page {currentPage.toLocaleString()} / {totalPages.toLocaleString()}
                                    </span>
                                    <div className="mcrb-pager-controls">
                                        <button
                                            type="button"
                                            className="mcrb-pager-btn"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Prev
                                        </button>
                                        {getPageNumbers(currentPage, totalPages).map((p, idx) =>
                                            p === "..." ? (
                                                <span key={`e-${idx}`} className="mcrb-pager-ellipsis">
                                                    &hellip;
                                                </span>
                                            ) : (
                                                <button
                                                    key={p}
                                                    type="button"
                                                    className={`mcrb-pager-num ${p === currentPage ? "is-active" : ""}`}
                                                    onClick={() => handlePageChange(p)}
                                                >
                                                    {p}
                                                </button>
                                            )
                                        )}
                                        <button
                                            type="button"
                                            className="mcrb-pager-btn"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </ThemeMaker>
    );
};

export default MrcProduct;
